import React, { useEffect, useState, useRef } from "react";

/**
 * Baloes das integracoes/canais, renderizados em linha horizontal
 * abaixo do subtitulo do Hero. Estilo bolha 3D com cor da marca.
 *
 * Comportamento:
 * - Aparecem em cascata quando o Hero entra no estagio1 (pela prop `estagio`).
 * - Ficam fixos durante o estagio1 e o estagio2 inteiros.
 * - Somem em cascata na transicao estagio2 -> estagio1 e reaparecem em seguida.
 * - Icones em SVG branco no meio da bolha colorida.
 * - VoIP tem icone custom (texto "VoIP" em branco).
 * - Anthropic usa o simbolo oficial "A" laranja sobre fundo bege.
 */

const CANAIS = [
  {
    id: "whatsapp",
    label: "WhatsApp",
    corFundo: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)",
    corSombra: "rgba(37, 211, 102, 0.5)",
    Icone: () => (
      <svg viewBox="0 0 24 24" className="w-5 h-5" fill="white">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
      </svg>
    ),
  },
  {
    id: "instagram",
    label: "Instagram",
    corFundo:
      "linear-gradient(135deg, #833ab4 0%, #fd1d1d 50%, #fcb045 100%)",
    corSombra: "rgba(253, 29, 29, 0.5)",
    Icone: () => (
      <svg viewBox="0 0 24 24" className="w-5 h-5" fill="white">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
      </svg>
    ),
  },
  {
    id: "facebook",
    label: "Facebook",
    corFundo: "linear-gradient(135deg, #1877F2 0%, #0D5FCC 100%)",
    corSombra: "rgba(24, 119, 242, 0.5)",
    Icone: () => (
      <svg viewBox="0 0 24 24" className="w-5 h-5" fill="white">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
      </svg>
    ),
  },
  {
    id: "telegram",
    label: "Telegram",
    corFundo: "linear-gradient(135deg, #0088CC 0%, #005580 100%)",
    corSombra: "rgba(0, 136, 204, 0.5)",
    Icone: () => (
      <svg viewBox="0 0 24 24" className="w-5 h-5" fill="white">
        <path d="M9.417 15.181l-.397 5.584c.568 0 .814-.244 1.109-.537l2.663-2.545 5.518 4.041c1.012.564 1.725.267 1.998-.931L23.906 3.821c.321-1.496-.541-2.081-1.527-1.714L2.34 9.83c-1.457.565-1.435 1.375-.248 1.742l5.13 1.602 11.893-7.505c.56-.373 1.07-.167.65.213z" />
      </svg>
    ),
  },
  {
    id: "chat_site",
    label: "Chat no site",
    corFundo: "linear-gradient(135deg, #10B981 0%, #059669 100%)",
    corSombra: "rgba(16, 185, 129, 0.5)",
    Icone: () => (
      <svg viewBox="0 0 24 24" className="w-5 h-5" fill="white">
        <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z" />
      </svg>
    ),
  },
  {
    id: "google",
    label: "Google",
    corFundo: "linear-gradient(135deg, #FFFFFF 0%, #F1F1F1 100%)",
    corSombra: "rgba(66, 133, 244, 0.4)",
    Icone: () => (
      <svg viewBox="0 0 24 24" className="w-5 h-5">
        <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
        <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
        <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
        <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
      </svg>
    ),
  },
  {
    id: "mercadopago",
    label: "Mercado Pago",
    corFundo: "linear-gradient(135deg, #00B1EA 0%, #009EE3 100%)",
    corSombra: "rgba(0, 158, 227, 0.5)",
    Icone: () => (
      <svg viewBox="0 0 24 24" className="w-5 h-5" fill="white">
        <path d="M22.5 12.5c-.2-.4-.6-.6-1-.5l-2.6.7c-.3.1-.6.1-.9-.1l-2.3-1.4c-.4-.2-.9-.3-1.4-.2l-3.2.8c-.3.1-.5.3-.5.6 0 .3.3.5.6.5l2.7-.3c.2 0 .4 0 .5.1l1.7 1.1c.5.3 1.1.4 1.7.3l2.5-.5c-.2.4-.5.7-.9.9l-4.1 1.9c-.5.2-1.1.2-1.6-.1l-3.4-1.8c-.4-.2-.9-.2-1.3 0l-2.2 1c-.3.1-.6-.1-.6-.4v-4.6c0-.3.2-.5.4-.6l4.8-2.2c.5-.2 1.1-.2 1.5 0l3.3 1.7c.4.2.9.3 1.3.1l3.4-.8c.3-.1.5-.4.4-.7 0-.2-.2-.4-.4-.5l-4-1.5c-.6-.2-1.3-.2-1.9 0L7.3 8.4c-.7.3-1.2.9-1.4 1.7L4.4 15c-.2.6.1 1.3.7 1.5l4 1.8c1 .5 2.2.5 3.2 0l4.9-2.3c.9-.4 1.6-1.2 1.9-2.1l.9-2.7c.1-.3-.1-.7-.5-.7z"/>
      </svg>
    ),
  },
  {
    id: "openai",
    label: "OpenAI",
    corFundo: "linear-gradient(135deg, #10A37F 0%, #0E8A6A 100%)",
    corSombra: "rgba(16, 163, 127, 0.5)",
    Icone: () => (
      <svg viewBox="0 0 24 24" className="w-5 h-5" fill="white">
        <path d="M22.282 9.821a5.985 5.985 0 0 0-.516-4.91 6.046 6.046 0 0 0-6.51-2.9A6.065 6.065 0 0 0 4.981 4.18a5.985 5.985 0 0 0-3.998 2.9 6.046 6.046 0 0 0 .743 7.097 5.98 5.98 0 0 0 .51 4.911 6.051 6.051 0 0 0 6.515 2.9A5.985 5.985 0 0 0 13.26 24a6.056 6.056 0 0 0 5.772-4.206 5.99 5.99 0 0 0 3.997-2.9 6.056 6.056 0 0 0-.747-7.073zM13.26 22.43a4.476 4.476 0 0 1-2.876-1.04l.141-.081 4.779-2.758a.795.795 0 0 0 .392-.681v-6.737l2.02 1.168a.071.071 0 0 1 .038.052v5.583a4.504 4.504 0 0 1-4.494 4.494zM3.6 18.304a4.47 4.47 0 0 1-.535-3.014l.142.085 4.783 2.759a.771.771 0 0 0 .78 0l5.843-3.369v2.332a.08.08 0 0 1-.033.062L9.74 19.95a4.5 4.5 0 0 1-6.14-1.646zM2.34 7.896a4.485 4.485 0 0 1 2.366-1.973V11.6a.766.766 0 0 0 .388.676l5.815 3.355-2.02 1.168a.076.076 0 0 1-.071 0l-4.83-2.786A4.504 4.504 0 0 1 2.34 7.872zm16.597 3.855l-5.833-3.387L15.119 7.2a.076.076 0 0 1 .071 0l4.83 2.791a4.494 4.494 0 0 1-.676 8.105v-5.678a.79.79 0 0 0-.407-.667zm2.01-3.023l-.141-.085-4.774-2.782a.776.776 0 0 0-.785 0L9.409 9.23V6.897a.066.066 0 0 1 .028-.061l4.83-2.787a4.5 4.5 0 0 1 6.68 4.66zm-12.64 4.135l-2.02-1.164a.08.08 0 0 1-.038-.057V6.075a4.5 4.5 0 0 1 7.375-3.453l-.142.08L8.704 5.46a.795.795 0 0 0-.393.681zm1.097-2.365l2.602-1.5 2.607 1.5v2.999l-2.597 1.5-2.607-1.5z" />
      </svg>
    ),
  },
  {
    id: "voip",
    label: "VoIP",
    corFundo: "linear-gradient(135deg, #06B6D4 0%, #0E7490 100%)",
    corSombra: "rgba(6, 182, 212, 0.5)",
    // Icone custom: texto "VoIP" branco em fonte compacta
    Icone: () => (
      <span
        className="text-white font-black leading-none tracking-tight"
        style={{ fontSize: "9px" }}
      >
        VoIP
      </span>
    ),
  },
  {
    id: "anthropic",
    label: "Anthropic",
    corFundo: "linear-gradient(135deg, #F5F0E8 0%, #E8DFCF 100%)",
    corSombra: "rgba(204, 120, 92, 0.4)",
    Icone: () => (
      <svg viewBox="0 0 94.1 65" className="w-5 h-5" fill="#CC785C">
        <path d="M66.5,0H51.4l27.5,65h15.1L66.5,0z M25.7,0L0,65h15.4l5.3-13.6h28.6L54.5,65h15.4L44.3,0H25.7z M25.7,38.6L35,14.4l9.3,24.2H25.7z"/>
      </svg>
    ),
  },
];

// Timings do loop
const DELAY_ENTRE_APARICOES_MS = 250;
const DELAY_ENTRE_SUMICOES_MS = 100;
const TEMPO_SEGURA_TODOS_ESCONDIDOS_MS = 400;

export default function BaloesCanais({ estagio }) {
  const [visiveis, setVisiveis] = useState({});
  const timeoutsRef = useRef([]);
  const estagioAnteriorRef = useRef(estagio);

  useEffect(() => {
    let cancelado = false;

    // Limpa timeouts pendentes do ciclo anterior
    timeoutsRef.current.forEach(clearTimeout);
    timeoutsRef.current = [];

    const estagioAnterior = estagioAnteriorRef.current;
    estagioAnteriorRef.current = estagio;

    if (estagio === "estagio1") {
      // Entrando no estagio1:
      // - Se veio do estagio2, precisa esconder todos e reaparecer em cascata.
      // - Se e o primeiro mount (estagioAnterior === estagio1), so aparece.

      if (estagioAnterior === "estagio2") {
        // Cascata de sumir primeiro, depois reaparecer.
        CANAIS.forEach((c, i) => {
          const t = setTimeout(() => {
            if (cancelado) return;
            setVisiveis((v) => ({ ...v, [c.id]: false }));
          }, i * DELAY_ENTRE_SUMICOES_MS);
          timeoutsRef.current.push(t);
        });

        const tempoParaReaparecer =
          CANAIS.length * DELAY_ENTRE_SUMICOES_MS +
          TEMPO_SEGURA_TODOS_ESCONDIDOS_MS;

        const tReaparecer = setTimeout(() => {
          if (cancelado) return;
          CANAIS.forEach((c, i) => {
            const t = setTimeout(() => {
              if (cancelado) return;
              setVisiveis((v) => ({ ...v, [c.id]: true }));
            }, i * DELAY_ENTRE_APARICOES_MS);
            timeoutsRef.current.push(t);
          });
        }, tempoParaReaparecer);
        timeoutsRef.current.push(tReaparecer);
      } else {
        // Primeiro mount: aparecem em sequencia
        CANAIS.forEach((c, i) => {
          const t = setTimeout(() => {
            if (cancelado) return;
            setVisiveis((v) => ({ ...v, [c.id]: true }));
          }, i * DELAY_ENTRE_APARICOES_MS);
          timeoutsRef.current.push(t);
        });
      }
    }
    // Se estagio === "estagio2", nao faz nada — baloes ficam como estao (visiveis).

    return () => {
      cancelado = true;
      // eslint-disable-next-line react-hooks/exhaustive-deps
      timeoutsRef.current.forEach(clearTimeout);
      timeoutsRef.current = [];
    };
  }, [estagio]);

  return (
    <div className="flex flex-wrap items-center gap-2" aria-hidden="true">
      {CANAIS.map((c) => {
        const ativo = !!visiveis[c.id];
        return (
          <div
            key={c.id}
            className={`transition-all duration-500 ease-out ${
              ativo
                ? "opacity-100 scale-100 translate-y-0"
                : "opacity-0 scale-50 translate-y-3"
            }`}
          >
            <div
              className="relative w-10 h-10 rounded-full flex items-center justify-center"
              style={{
                background: c.corFundo,
                boxShadow: `0 5px 14px ${c.corSombra}, inset 0 -2px 5px rgba(0,0,0,0.2)`,
              }}
            >
              {/* Highlight de brilho no topo (efeito bolha) */}
              <div
                className="absolute top-1 left-1.5 w-3 h-1.5 rounded-full opacity-60 pointer-events-none"
                style={{
                  background:
                    "radial-gradient(ellipse at center, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0) 70%)",
                }}
              />
              <c.Icone />
            </div>
          </div>
        );
      })}
    </div>
  );
}
